module.exports = __webpack_public_path__ + "static/media/226GR.2262f1eb.jpg";